// Small pill segmented control (All / To pay / Paid, Month / Year / All time, …).
export default function Segmented({
  value,
  onChange,
  options,
}: {
  value: string;
  onChange: (v: string) => void;
  options: [string, string][];
}) {
  return (
    <div className="segmented">
      {options.map(([val, label]) => (
        <button
          key={val}
          className={"segmented__btn" + (value === val ? " is-active" : "")}
          onClick={() => onChange(val)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
